import axios from "axios";

export const USPTOCategoryService = { getList };

function getList({ termId, search, description, isGoods, page, count }) {
  return new Promise(resolve => {
    axios
      .get(`${process.env.NEXT_PUBLIC_REACT_TRADEMARK_API}/trademarks/categories`, {
        params: {
          termId,
          search,
          description,
          isGoods,
          page,
          count,
        },
      })
      .then(response => {
        const data = response?.data ? { ...response?.data } : {};
        
        resolve({ ...data });
      })
      .catch(e => {
        resolve({ 
          elements: [],
          maxPerPage: count,
          totalResults: 0,
         });
      });
  });
}
